// Weight is received in stones and we need to format it in pounds + stones
// 14 pounds is a stone
export default (weight) => {
  const weightAsInt = parseInt(weight, 10);

  return `${Math.floor(weightAsInt / 14)}-${weightAsInt % 14}`;
};
